import PropTypes from 'prop-types';

import { SquareWithRoundBordersShape } from '../SquareWithRoundBordersShape';

export function SalesChannelLegendLabel({ x, label, color }) {
  return (
    <g transform={`translate(${x} 0)`} key={label}>
      <SquareWithRoundBordersShape fill={color} size={8} />
      <text x="12" y="11" fontFamily="Rubik" fontSize={12} fontWeight={300}>
        {label}
      </text>
    </g>
  );
}

SalesChannelLegendLabel.propTypes = {
  x: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};
